export default __webpack_public_path__ + "static/media/back-button.0412df15.svg";